import { useEffect, useState } from 'react';
import { base } from '../store/api';

export const useFetchSloganData = () => {
  const [slogan, setSlogan] = useState(undefined);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${base}/en/api/slogan/`)
      .then((res) => {
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }
        return res.json();
      })
      .then((data) => {
        if (data && data.id && data.translations) {
          setSlogan(data);
        } else {
          console.warn('Invalid slogan data structure');
          setSlogan(undefined);
        }
      })
      .catch((error) => {
        console.error('Ошибка загрузки данных:', error);
      })
      .finally(() => setLoading(false));
  }, []);

  return { slogan, loading };
};
